import React from "react";
import { Text, View } from "react-native";

import { messageSharedStyles as styles } from "./MessageShared.styles";

type MessageBubbleProps = {
  body: string;
  isOutbound: boolean;
  timestamp?: string;
  statusNode?: React.ReactNode;
  attachmentsNode?: React.ReactNode;
};

const MessageBubble: React.FC<MessageBubbleProps> = ({
  body,
  isOutbound,
  timestamp,
  statusNode,
  attachmentsNode,
}) => {
  const showMeta = !!(timestamp || statusNode);

  return (
    <View style={[styles.bubbleRow, isOutbound && styles.bubbleRowOutbound]}>
      <View
        style={[
          styles.bubbleContentColumn,
          isOutbound && styles.bubbleContentColumnOutbound,
        ]}
      >
        <View
          style={[
            styles.bubbleContainer,
            isOutbound
              ? styles.bubbleContainerOutbound
              : styles.bubbleContainerInbound,
          ]}
        >
          <Text style={styles.bubbleMessageText}>{body}</Text>
          {attachmentsNode}
        </View>
      </View>
      {showMeta ? (
        <View style={styles.bubbleMetaColumn}>
          <View style={styles.bubbleFooterRow}>
            {statusNode || null}
            <Text style={styles.bubbleTimestamp}>{timestamp || ""}</Text>
          </View>
        </View>
      ) : null}
    </View>
  );
};

export default MessageBubble;
